const initState = {
  loaded: true,
  reported: [],
  banned: [],
  error: [],
};

const userReducer = (state = initState, action) => {
  switch (action.type) {
    case "FETCH_ADMIN_REQUEST":
      return {
        ...state,
        loaded: false,
      };
    case "FETCH_ADMIN_REPORTED_FAILURE":
      return {
        ...state,
        loaded: true,
        reported: [],
      };
    case "FETCH_ADMIN_REPORTED_SUCCESS":
      return {
        ...state,
        loaded: true,
        reported: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
